import styled from 'styled-components/native';

import BillDetailSection from '../../../components/CheckoutPage/BillDetailSectionContainer';

const DetailSection = () => {
  return (
    <S.Container>
      <BillDetailSection page="cart" />
    </S.Container>
  );
};

const S = {
  Container: styled.View`
    border-radius: 1px;
    border: 1px dashed ${({ theme }) => theme.palette.neutralLight};
  `,
};

export default DetailSection;
